<ion-card mode="ios">
    <ion-card-header color="">
        <ion-card-title color="primary">
            {{ (report.hideManagerEvaluation ? 'performanceCycle.selfEvaluation' : 'finalReport.selfManagerEvaluation') | translate | uppercase }}
        </ion-card-title>
    </ion-card-header>
    <ion-card-content class="ion-no-padding">
        <ion-grid class="team">
            <ng-container *ngFor="let group of getQuestionsGroups(report.processConfigs); let gIndex = index">
                <ng-container *ngIf="group.globalizationConfig['pt-BR'].title != 'MÉDIA AUTOAVALIAÇÃO'">
                    <ion-row size="12" class="section">
                        <ion-col>{{ getText(group.globalizationConfig, 'title') }}</ion-col>
                        <ng-container *ngIf="group.globalizationConfig['pt-BR'].title == 'Média'">
                            <ion-col>{{ 'headEvaluation.selfEvaluation' | translate }}</ion-col>
                            <ion-col>{{ 'headEvaluation.managerEvaluation' | translate }}</ion-col>
                        </ng-container>
                    </ion-row>
                    <ion-row class="header">
                        <ion-col></ion-col>
                        <ion-col class="user">
                            <img [src]="getImageUrl(report.user.imageUrl)" default="" alt=""/>
                            <p>
                                <b>{{ report.user.name }}</b><br>
                                {{ 'generic.employee' | translate }}
                            </p>
                        </ion-col>
                        <ion-col *ngIf="!report.hideManagerEvaluation" class="user">
                            <img [src]="getImageUrl(report.lineManager.imageUrl)" default="" alt=""/>
                            <p>
                                <b>{{ report.lineManager.name }}</b><br>
                                {{ 'generic.manager' | translate }}
                            </p>
                        </ion-col>
                    </ion-row>

                    <ng-container *ngFor="let question of group.questions; let qIndex = index">
                        <ng-container *ngIf="question.type === QuestionConfigType.GoalsFinalGrade">
                            <ion-row class="body" *ngFor="let goal of report.goals">
                                <ion-col>
                                    <p class="title">
                                        {{ goal.title }}
                                    </p>
                                    <p class="description">
                                        {{ goal.description }}
                                    </p>
                                    <div class="deadline">
                                        <p class="date">
                                            {{ goal.deadline | date : 'dd/MM/yyyy' }}
                                        </p>
                                        <div class="progress-bar-container"
                                             [ngClass]="{
                                                            'primary': getProgressBarColor(goal, 'primary'),
                                                            'danger': getProgressBarColor(goal, 'danger'),
                                                            'warning': getProgressBarColor(goal, 'warning')
                                                          }">
                                            <div class="prohress-bar">
                                                <span [ngStyle]="getProgressBarLength(goal)"></span>
                                            </div>
                                            <div class="progress-bar-status">
                                                {{ goal.currentProgress }}%
                                            </div>
                                        </div>
                                        <p id="view-goal" class="viewGoal hideFromPrinting" (click)="viewGoalModal(goal)">
                                            {{ 'generic.view' | translate }}
                                        </p>
                                    </div>
                                </ion-col>
                                <ion-col>
                                    {{ getGlobalizedValue(goal.finalSelfEvaluation, getGoalsQuestion()) || '--' }}
                                </ion-col>
                                <ion-col *ngIf="!report.hideManagerEvaluation">
                                    {{ getGlobalizedValue(goal.finalManagerEvaluation, getGoalsQuestion()) || '--' }}
                                </ion-col>
                            </ion-row>
                        </ng-container>
                        <ng-container *ngIf="question.type !== QuestionConfigType.Goals">
                            <ion-row class="body">
                                <ion-col
                                        [ngClass]="{ 'highlight': (shouldHighlight(question) && highlightGoalsFinalGradeAnswer) }">
                                    <b>{{ getText(question.globalizationConfig, 'title') }}</b>
                                </ion-col>
                                <ion-col
                                        [ngClass]="{ 'highlight': (shouldHighlight(question) && highlightGoalsFinalGradeAnswer) }">
                                    {{ report.selfEvaluation ? question.hideQuestion ? '-' : getGlobalizedValue(report.selfEvaluation['field' + question.order], question) : '--' }}
                                </ion-col>
                                <ion-col *ngIf="!report.hideManagerEvaluation"
                                         [ngClass]="{ 'highlight': (shouldHighlight(question) && highlightGoalsFinalGradeAnswer) }">
                                    {{ report.managerEvaluation ? question.hideQuestion ? '-' : getGlobalizedValue(report.managerEvaluation['field' + question.order], question) : '--' }}
                                </ion-col>
                            </ion-row>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="showFinalResult">
                <ion-row size="12" class="section">
                    {{ 'performanceCycle.FinalResult' | translate }}
                </ion-row>
                <ion-row class="header">
                    <ion-col></ion-col>
                    <ion-col class="user">
                        <img [src]="getImageUrl(report.user.imageUrl)" default="" alt=""/>
                        <p>
                            <b>{{ report.user.name }}</b><br>
                            {{ 'performanceCycle.selfEvaluation' | translate }}
                        </p>
                    </ion-col>
                    <ion-col *ngIf="!report.hideManagerEvaluation" class="user">
                        <img [src]="getImageUrl(report.lineManager.imageUrl)" default="" alt=""/>
                        <p>
                            <b>{{ report.lineManager.name }}</b><br>
                            {{ 'generic.manager' | translate }} / {{ 'calibration.calibration' | translate }}
                        </p>
                    </ion-col>
                </ion-row>
                <ion-row class="body">
                    <ion-col>
                    </ion-col>
                    <ion-col>
                        {{ selfFinalGrade }}
                    </ion-col>
                    <ion-col>
                        {{ managerFinalGrade }}
                    </ion-col>
                </ion-row>
            </ng-container>
        </ion-grid>
    </ion-card-content>
</ion-card>